import { dataRecommendation } from 'dls-icons-data'
import { createIcon } from '../common'

const IconRecommendation = /*#__PURE__*/createIcon(dataRecommendation)
export default IconRecommendation
